import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import "../AddpropertyByMls/AddpropertyByMls.css";
import { timing } from "../../data/states";
import Residin from "../../myimgs/Union (2).png";
import Vectors from "../../myimgs/Vector (4).png";

export default function AddMLSUI() {
  const [mls, setMls] = useState("");
  const [showDetails, setShowDetails] = useState(false);
  const [propertyData, setPropertyData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showOfferForm, setShowOfferForm] = useState(false);
  const [isResidential, setIsResidential] = useState(true);

  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    offerStartingPrice: "",
    offerStartingDate: "",
    offerStartingTime: "",
    offerEndingDate: "",
    offerEndingTime: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const [year, month, day] = dateString.split("-");
    return `${day}-${month}-${year}`;
  };

  // SEARCH MLS
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!mls.trim()) return;

    try {
      setLoading(true);
      const res = await axios.get(
        // `${process.env.REACT_APP_API_BASE_URL}/property/get-by-mls/${mls}`,
        `${process.env.REACT_APP_API_BASE_URL}/property/property-by-mls?listingId=${mls}&isResidential=${isResidential}`
      );

      if (res.data?.data) {
        setPropertyData(res.data.data);
        setShowDetails(true);
      }
    } catch (error) {
      console.log("API Error:", error);

      const apiMessage =
        error?.response?.data?.message || "Something went wrong!";

      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: apiMessage,
      });
    } finally {
      setLoading(false);
    }
  };

  // PREVIEW BUTTON
  const handleViewDetails = (id, propeId) => {
    const url = `/propertyDetail?id=${id}&propeId=${propeId}`;
    window.open(url, "_blank");
  };

  // SUBMIT WITH OFFER
  const handleOfferSubmit = async () => {
    if (
      !formData.offerStartingPrice ||
      !formData.offerStartingDate ||
      !formData.offerStartingTime ||
      !formData.offerEndingDate ||
      !formData.offerEndingTime
    ) {
      Swal.fire("Warning!", "Please fill all fields", "warning");
      return;
    }

    const payload = {
      userId: localStorage.getItem("userId"),
      offerStartingPrice: formData.offerStartingPrice,
      offerStartingDate: formatDate(formData.offerStartingDate),
      offerStartingTime: formData.offerStartingTime,
      offerEndingDate: formatDate(formData.offerEndingDate),
      offerEndingTime: formData.offerEndingTime,
    };

    try {
      await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/property/add-by-mls/${propertyData?.listingId}`,
        payload,
        { headers: { "Content-Type": "application/json" } },
      );

      Swal.fire({
        title: "Listing Request Sent To Twoffers!",
        text: "Your new listing request has been sent successfully",
        icon: "success",
        confirmButtonText: "Go to My Listings",
        allowOutsideClick: false,
        allowEscapeKey: false,
      }).then((result) => {
        if (result.isConfirmed) {
          navigate("/myListings");
        }
      });

      setShowOfferForm(false);
    } catch (error) {
      console.log("Offer API Error:", error);
      Swal.fire("Error!", "Something went wrong!", "error");
    }
  };

  // SUBMIT WITHOUT OFFER
  const handleSubmitWithoutOffer = async () => {
    const payload = { userId: localStorage.getItem("userId") };

    try {
      await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/property/add-by-mls/${propertyData?.listingId}`,
        payload,
        { headers: { "Content-Type": "application/json" } },
      );

      Swal.fire({
        title: "Listing Request Sent To Twoffers!",
        text: "Your new listing request has been sent successfully",
        icon: "success",
        confirmButtonText: "Go to My Listings",
        allowOutsideClick: false,
        allowEscapeKey: false,
      }).then((result) => {
        if (result.isConfirmed) {
          navigate("/myListings");
        }
      });
    } catch (error) {
      console.log("API Error:", error);
      Swal.fire("Error!", "Something went wrong!", "error");
    }
  };
  return (
    <div className="w-full min-h-screen bg-white  py-6 addpromls">
      {/* HEADER */}
      <div className="flex items-center gap-3 mb-6">
        <h1 className="text-xl font-semibold">Add Property By MLS</h1>
        <div className="resideciolbtn">
          <button
            type="button"
            onClick={() => setIsResidential(true)}
            className={isResidential ? "activeBtn" : ""}
          >
            <img src={Residin} alt="" /> Residential
          </button>

          <button
            type="button"
            onClick={() => setIsResidential(false)}
            className={!isResidential ? "activeBtn" : ""}
          >
            <img src={Vectors} alt="" /> Commercial
          </button>
        </div>
      </div>

      {/* SEARCH CARD */}
      <div className="bg-white p-6 rounded-2xl shadow-md border mb-6">
        <h2 className="text-xl font-semibold mb-3 text-center">
          Search Property by MLS
        </h2>

        <form onSubmit={handleSubmit} className="flex flex-col gap-3">
          <input
            type="text"
            placeholder="Enter MLS Number"
            value={mls}
            onChange={(e) => setMls(e.target.value)}
            className="border border-gray-300 p-3 rounded-lg text-base focus:ring-2 focus:ring-blue-500 outline-none"
          />

          <button type="submit" className="view-btn kji" disabled={loading}>
            {loading ? "Searching..." : "Search"}
          </button>
        </form>
      </div>

      {/* PROPERTY CARD */}
      {showDetails && propertyData && (
        <div className="bg-white rounded-xl shadow-md border overflow-hidden hjuju">
          <img
            src={
              propertyData?.propertyImages?.[0]?.imageUrl || "/sample-map.jpg"
            }
            alt="Property"
            className="w-full h-48 object-cover"
          />

          <div className="vcardf">
            <h2 className="text-lg font-bold text-gray-900">
              {propertyData.propertySubType || ""}
            </h2>

            <p className="text-gray-600 text-sm mt-1">
              <strong>MLS NO:</strong> {propertyData.listingId || ""}
            </p>

            <div className="flex items-start gap-2 text-sm mt-3">
              <span className="text-lg">📍</span>
              <span>{propertyData.unparsedAddress}</span>
            </div>

            <div className="flex items-center gap-4 mt-4 text-sm text-gray-700">
              {propertyData.buildingAreaTotal && (
                <div className="flex items-center gap-1">
                  <span>📏</span> {propertyData.buildingAreaTotal} ft
                </div>
              )}
            </div>
          </div>

          <div className="mt-5 border-t pt-4 flex justify-between items-center kiokokkk">
            {/* <p className="text-green-600 text-2xl font-bold">
              ${propertyData?.listPrice?.toLocaleString() || ""}
            </p> */}

            <div className="CURENTSd">
              <div className="price-section">
                {/* <p className="price-label">Current Valuation</p> */}
              </div>
              <h4 className="prices">
                {(() => {
                  if (propertyData?.liveBid) {
                    return `$${Number(propertyData?.liveBid).toLocaleString()}`;
                  }

                  const details = propertyData?.biddingDetails;

                  if (!details) {
                    return `$${
                      propertyData?.listPrice?.toLocaleString() || "N/A"
                    }`;
                  }

                  const { currenntAuctionAmount, bidStartingValue } = details;

                  if (
                    currenntAuctionAmount !== null &&
                    currenntAuctionAmount !== undefined
                  ) {
                    return `$${Number(currenntAuctionAmount).toLocaleString()}`;
                  }

                  if (
                    bidStartingValue !== null &&
                    bidStartingValue !== undefined
                  ) {
                    return `$${Number(bidStartingValue).toLocaleString()}`;
                  }

                  return "$N/A";
                })()}
              </h4>
            </div>

            <button
              onClick={() => {
                handleViewDetails(propertyData.id, propertyData.propeId);
              }}
              className="view-btn"
              style={{ float: "right" }}
            >
              Preview
            </button>
          </div>
        </div>
      )}

      {/* BUTTONS */}
      {showDetails && (
        <div className="offerpropdf border">
          <p className="mt-8 text-lg font-medium text-gray-800 text-center">
            Do you want to add offer on this Property?
          </p>
          <div className="flex flex-col gap-4 px-2">
            <button
              className="view-btn kji"
              onClick={() => setShowOfferForm(true)}
            >
              Add Offer Starting Price
            </button>

            <button
              className="view-btn kji"
              onClick={handleSubmitWithoutOffer}
              style={{ display: "none" }}
            >
              Submit Without Offer
            </button>
          </div>
        </div>
      )}

      {showOfferForm && (
        <div className="offer-modal-overlay">
          <div className="offer-modal">
            <button
              className="offer-close-btn"
              onClick={() => setShowOfferForm(false)}
            >
              ×
            </button>

            <h3 className="offer-label">Offer Starting Price</h3>
            <input
              type="number"
              name="offerStartingPrice"
              value={formData.offerStartingPrice}
              onChange={handleChange}
              className="offer-input"
              placeholder="Offer Starting Price"
            />

            <div className="offer-row">
              <div className="offer-col">
                <h3 className="offer-label">Offer Start Date</h3>
                <input
                  type="date"
                  name="offerStartingDate"
                  value={formData.offerStartingDate}
                  onChange={handleChange}
                  className="offer-input"
                />
              </div>

              <div className="offer-col">
                <h3 className="offer-label">Offer End Date</h3>
                <input
                  type="date"
                  name="offerEndingDate"
                  value={formData.offerEndingDate}
                  onChange={handleChange}
                  className="offer-input"
                />
              </div>
            </div>

            <div className="offer-row">
              <div className="offer-col">
                <label className="offer-label">Offer Starting Time</label>
                <select
                  name="offerStartingTime"
                  value={formData.offerStartingTime}
                  onChange={handleChange}
                  className="offer-input"
                >
                  <option value="">Select</option>
                  {timing.map((time) => (
                    <option key={time} value={time}>
                      {time}
                    </option>
                  ))}
                </select>
              </div>

              <div className="offer-col">
                <label className="offer-label">Offer Ending Time</label>
                <select
                  name="offerEndingTime"
                  value={formData.offerEndingTime}
                  onChange={handleChange}
                  className="offer-input"
                >
                  <option value="">Select</option>
                  {timing.map((time) => (
                    <option key={time} value={time}>
                      {time}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <p className="offer-note">Note: Please fill All Information</p>

            <button className="offer-submit-btn" onClick={handleOfferSubmit}>
              SUBMIT
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
